import { DataTable, Loading } from "@aidkitorg/component-library";
import { MessageTemplate } from "@aidkitorg/types/lib/survey";
import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { usePost } from "../../API";

export function PromptDirectory() {
  const getAllMessageTemplates = usePost('/program/admin/prompts/scan');

  const [messageTemplates, setMessageTemplates] = useState<MessageTemplate[]>([]);

  const history = useHistory();
  const [loadingAllTemplates, setLoadingAllTemplates] = useState(false);
  const searchTimer = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    setLoadingAllTemplates(true);
    searchTimer.current = setTimeout(async () => {
      const { nameToVersionsAndDescriptionsMap } = await getAllMessageTemplates({});
      const templateNames = Object.keys(nameToVersionsAndDescriptionsMap);
      const templates: MessageTemplate[] = [];
      if (templateNames.length > 0) {
        templateNames.forEach(name => {
          nameToVersionsAndDescriptionsMap[name].forEach(versionAndDescription => {
            templates.push({
              kind: "Message Template",
              instructions: [],
              name: name,
              version: versionAndDescription.version,
              description: versionAndDescription.description,
            } satisfies MessageTemplate);
          });
        });
      }
      setMessageTemplates(templates);
      setLoadingAllTemplates(false);
    }, 500);
    return () => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
    }
  }, []);

  return <div className="mt-4 bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg space-y-4 p-2">
    <div className="flex flex-col space-y-2">
      <h2 className="text-lg font-semibold">Directory</h2>
      <Loading loading={loadingAllTemplates}>
        <DataTable 
          enableSearch={true}
          searchLabel="Search by name"
          columns={[{
            accessorKey: 'name',
            header: 'Name',
          }, {
            accessorKey: 'version',
            header: 'Version',
          }, {
            accessorKey: 'description',
            header: 'Description',
          }]}
          data={messageTemplates}
          actions={[{
            label: 'Edit',
            onClick: (row) => {
              history.push(`/ai/config/prompts?name=${row.name}&version=${row.version}`);
            }
          }]}
        />
      </Loading>
    </div>
  </div>
}